import { useEffect, useState } from 'react';

/**
 * This hooks unifies the same behaviour of showing
 * the header menu (hamburger menu) on different platforms
 */
const breakpoints = [
  { query: window.matchMedia('(max-width: 1024px)'), maxItems: 0 },
  { query: window.matchMedia('(max-width: 1440px)'), maxItems: 4 },
  { query: window.matchMedia('(min-width: 1440px)'), maxItems: 5 },
];

const shouldCollapse = (navItems: number) => {
  return breakpoints.some(({ query, maxItems }) => query.matches && navItems > maxItems);
};

export const useMenuCollapse = (navItems: number) => {
  const [collapsed, setCollapsed] = useState(() => shouldCollapse(navItems));

  useEffect(() => {
    const update = () => setCollapsed(shouldCollapse(navItems));

    breakpoints.forEach(({ query }) => query.addEventListener('change', update));
    update();

    return () => {
      breakpoints.forEach(({ query }) => query.removeEventListener('change', update));
    };
  }, [navItems]);

  return collapsed;
};
